import { render, staticRenderFns } from "./PageTwoAddBenefitModal.vue?vue&type=template&id=6d17a53c&scoped=true"
import script from "./PageTwoAddBenefitModal.vue?vue&type=script&lang=js"
export * from "./PageTwoAddBenefitModal.vue?vue&type=script&lang=js"
import style0 from "./PageTwoAddBenefitModal.vue?vue&type=style&index=0&id=6d17a53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d17a53c",
  null
  
)

export default component.exports